<template>
  <div>
    <div v-for="(note, i) in notes" :key="i"  prominent text color="red">
        <note :note="note" deletable :editable="false" :no-tab-focus="noTabFocus" @deleted="deleteNote"></note>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SiteNotes',

  beforeMount() {},
  data: () => ({}),
  props: {
    notes: {
      type: Array,
      default: null,
    },
    noTabFocus: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    deleteNote(note) {
      this.notes.splice(this.notes.findIndex(n => n.id == note.id), 1)
    },
  },
  watch: {},
}
</script>
